import { useRef, type CSSProperties } from 'react';
import styles from './skeleton-styles.module.css';
import { AnimatePresence, motion } from 'motion/react';
import type { SkeletonLoaderOptions } from './skeleton-loader-props';
import randomString from '@/utils/random-string';

export default function SkeletonRect(props: SkeletonLoaderOptions) {
  const key = useRef(randomString(7));

  return (
    <AnimatePresence>
      {props.loading && (
        <motion.div
          className={'loading-overlay'}
          style={props.justify ? { alignItems: props.justify } : {}}
          exit={{ opacity: 0 }}
          key={`loader-${key.current}`}
        >
          <motion.div className={styles.skeletonLoaderContainer}>
            <svg
              style={
                {
                  ...props,
                  borderRadius: props.radius ?? '8px',
                  '--background-color': props.backgroundColor ?? 'var(--BG)',
                  '--rate': props.rate,
                } as CSSProperties
              }
              className={`${styles.skeletonLoader} ${props.design ? styles[props.design] : ''}`}
            >
              <rect
                height={props.height ?? '100%'}
                width={props.width ?? '100%'}
                className={styles.skeletonLoaderRect}
                rx={props.radius ?? '8px'}
              />
            </svg>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
